module.exports = __webpack_public_path__ + "media/images/ac_templates/201/blk-6c68b124d63d62cbed04fd28d50d996c.jpg";